module.exports = __webpack_public_path__ + "static/assets/d458676cda22e1f03779482da4a2bdf0.png";